module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/aqgjfw.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Faqgjfw.png
// module id = JgIL
// module chunks = 93